import Vue from 'vue'
import {gaSendEvent, gaSendExperiment, gaSendPageview, installGoogleAnalytics} from "@/components/Analytics";
import Home2 from "@/views/Home2.vue";
import Header from "@/components/Header.vue";
import FacebookReviews from "@/components/FacebookReviews.vue";
import License from "@/components/License.vue";
import HeaderCss from "@/components/HeaderCss.vue";

installGoogleAnalytics();
Vue.config.productionTip = false;

new Vue({
  render: h => h(Home2)
}).$mount('#home2-mount');
new Vue({
  render: h => h(HeaderCss)
}).$mount("#header-css");
// new Vue({
//   render: h => h(FacebookReviews)
// }).$mount("#facebook-reviews-mount");
new Vue({
  render: h => h(FacebookReviews)
}).$mount("#facebook-reviews-job");
new Vue({
  render: h => h(FacebookReviews)
}).$mount("#facebook-reviews-trust");
new Vue({
  render: h => h(License)
}).$mount("#license-mount1");
new Vue({
  render: h => h(License)
}).$mount("#license-mount2");

gaSendPageview("/");
gaSendEvent("Landing V4 OFF", {});
